export default {"cs":0.04,"de":0.96,"en":1,"es":0.84,"et":0.5,"fr":0.07,"nb-NO":0.04,"ru":0.14,"ta":0.92,"uk":0.32,"zh-Hant":0.29,"ja":0,"zh-Hans":0.01}